import fobclient from 'fobclient'
import store from '@/store'

class Connection {
  constructor (data) {
    this.baseURL = data.baseURL
    this.port = data.port || ''
    this.username = data.username
    this.password = data.password
    this.token = data.token
    this.path = data.path || ''
    this.transformator = data.transformator || (x => x)
  }

  setConnection ({ baseURL, username, password, port, path, transformator }) {
    this.baseURL = baseURL
    this.username = username
    this.password = password
    this.path = path || '/login'
    this.port = port || ''
    this.transformator = transformator
  }

  getURIPrefix () {
    let uriPrefix = this.baseURL
    if (this.port) {
      uriPrefix += `:${this.port}`
    }
    uriPrefix += this.path
    return uriPrefix
  }

  getBaseURL () {
    return this.baseURL
  }

  getPort () {
    return this.port
  }

  getPath () {
    return this.path
  }

  getTransformator () {
    return this.transformator
  }

  getConnection () {
    return {
      baseURL: this.baseURL,
      username: this.username,
      password: this.password,
      port: this.port,
      token: this.token
    }
  }

  getToken () {
    return store.getters['user/token']
  }

  setToken () {
    // token not in connection, as pulled from store
  }
}

fobclient.init(
  new Connection({
    baseURL: process.env.FOB_BACKEND_URL,
    path: process.env.FOB_BACKEND_PATH,
    port: process.env.FOB_BACKEND_PORT
  }),
  // TOMANER
  new Connection({
    baseURL: process.env.ALT_LOGIN_URL || process.env.FOB_BACKEND_URL,
    port: process.env.ALT_LOGIN_PORT || process.env.FOB_BACKEND_PORT,
    path: process.env.ALT_LOGIN_PATH,
    transformator: process.env.ALT_LOGIN_TRANSFORMATOR
  })
)

export default fobclient



// WEBPACK FOOTER //
// ./src/fobclient/index.js